// Store del modal de "Reservar demo". Lo usan todos los CTAs de la landing
// (hero, pricing, cta-footer, industry-strip) para abrir el mismo modal.

import { create } from 'zustand';

export interface BookDemoPrefill {
  industry?: string;
  message?: string;
  plan?: string;
}

interface BookDemoState {
  isOpen: boolean;
  prefill: BookDemoPrefill | null;
  open: (prefill?: BookDemoPrefill) => void;
  close: () => void;
}

export const useBookDemoStore = create<BookDemoState>((set) => ({
  isOpen: false,
  prefill: null,
  open: (prefill) => set({ isOpen: true, prefill: prefill ?? null }),
  close: () => set({ isOpen: false, prefill: null }),
}));
